<template>
  <!-- <div class="grid-class flexV bg-white" :class="{ 'border': borderRule === 'all' }"> -->
  <div
    class="grid-class ag-grid-wrap flexV bg-white"
    :style="style"
  >
    <slot />
  </div>
</template>

<script>
// import '../../../../lib/styles/components/AgGridWrap.scss'
export default {
  name: 'AgGridWrap',
  props: {
    // 边框
    borderRule: {
      // all、none、bottom、except-top、except-bottom、except-right、except-left、top-bottom、left-right
      type: String,
      default: 'except-top'
    },
    // 边框
    borderRadius: {
      // all、seesaw、none
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      style: {
        height: ''
      }
    }
  }
}
</script>
